module.exports = __webpack_public_path__ + "static/media/logo-cscs.ae3aba9c.png";